import React from "react";
import headerImage from "../assets/header.png";

const Header = () => {
    return <img src={headerImage} className="h-52 hidden sx:flex flex-none" alt="header" />;
};

export default Header;
